const hlsMimeTypeRegexp = /^application\/(?:x-mpegURL|vnd\.apple\.mpegurl)$/i;
const hlsExtensionRegexp = /\.m3u8\b/i;

export default {
  isHlsSource: (source) => {
    if (hlsMimeTypeRegexp.test(source.type)) {
      return 'probably';
    } else if (hlsExtensionRegexp.test(source.src)) {
      return 'maybe';
    } else {
      return '';
    }
  },

  isHlsType: (type) => {
    if (hlsMimeTypeRegexp.test(type)) {
      return 'probably';
    }
    return '';
  }
}



// WEBPACK FOOTER //
// ./src/source-handlers/_hls-utils.js